/**
 * LoggingMiddleware
 *
 * The LoggingMiddleware logs each incoming action to the console.
 *
 * @module middleware/Logging
 */
import { shouldTrapErrors } from '../lib/configuration/DebugSettingsUtil';
import Logger from '../tools/Logger';

const log = Logger.child({ component: 'middleware/Logging' });

/**
 * Pass incoming actions to ActionRouter
 *
 * @param  {object} store - redux
 * @param  {object} next - dispatch function of next middleware in the chain
 * @param  {object} action - the current action
 * @returns {Promise} resolution of the workflow
 */
export default (/* store*/) => next => action => {
  if (!shouldTrapErrors()) {
    return next(action);
  }
  try {
    return next(action);
  } catch (err) {
    log.error(
      {
        obj: err,
      },
      `${action.type}: unhandled error`,
    );
  }
};
